import React from "react";
import { PhoneIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { business } from "../data/business";
import { navLinks } from "../data/navigation";
import { services } from "../data/services";
import { ui } from "../data/ui";
import { LanguageToggle } from "./LanguageToggle";
import { Logo } from "./Logo";
import { NewsletterForm } from "./NewsletterForm";
export function Footer() {
  const {
    t
  } = useLanguage();
  const year = new Date().getFullYear();
  const quickLinks = navLinks;
  const heading = "text-xs font-semibold uppercase tracking-[0.18em] text-gold";
  const link = "link-slide text-[15px] text-white/80 hover:text-white";
  return <footer className="bg-ink" data-id="element-129" data-mp="3qcnkwuiq8t0q">
      <div className="bg-gold" data-id="element-130" data-mp="3qbvo5gde8p8v">
        <div className="mx-auto flex max-w-7xl flex-col gap-5 px-5 py-8 sm:px-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-131" data-mp="29z6tk9nn6feu">
          <div data-id="element-132" data-mp="2eyjs3rnvlax9">
            <p className="font-display text-2xl font-bold uppercase text-ink" data-id="element-133" data-mp="2ezbeqczhvybe">{t(ui.footer.newsTitle)}</p>
            <p className="mt-1 text-sm text-ink/80" data-id="element-134" data-mp="3labqfslx60os">{t(ui.footer.newsSub)}</p>
          </div>
          <NewsletterForm data-id="element-135" data-mp="3gbr0qn4amzel" />
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8" data-id="element-136" data-mp="3v7q7nufo2ti5">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-12 lg:gap-8" data-id="element-137" data-mp="3v9azvdeie0cu">
          <div className="sm:col-span-2 lg:col-span-3" data-id="element-138" data-mp="3q7llpovzp6kj">
            <Logo size="footer" data-id="element-139" data-mp="830hxf7jlyyw" />
            <address className="mt-6 not-italic text-[15px] leading-relaxed text-white/80" data-id="element-140" data-mp="81yvkel2tq1v">
              {business.street}
              <br data-id="element-141" data-mp="33e4b4nsygpk" />
              {business.plaza}
              <br data-id="element-142" data-mp="hsk0ejrcfqt8" />
              {business.city}, {business.region} {business.postalCode}
            </address>
            <p className="mt-5 font-display italic text-gold" data-id="element-143" data-mp="ctgwj2n3nqmu">{t(ui.common.tagline)}</p>
          </div>

          <nav aria-labelledby="footer-links" className="lg:col-span-2" data-id="element-144" data-mp="qsqfga2owyui">
            <h2 id="footer-links" className={heading} data-id="element-145" data-mp="ms6gd0yk3l5q">{t(ui.footer.quickLinks)}</h2>
            <ul className="mt-5 space-y-3" data-id="element-146" data-mp="mq3hdrffehov">
              {quickLinks.map(l => <li key={l.href} data-id="element-147" data-mp="tt090qdpumqh"><a href={l.href} className={link} data-id="element-148" data-mp="yu7g0n81bhw3">{t(l.label)}</a></li>)}
            </ul>
          </nav>

          <nav aria-labelledby="footer-services" className="lg:col-span-2" data-id="element-149" data-mp="13sr3is2a11qk">
            <h2 id="footer-services" className={heading} data-id="element-150" data-mp="13rg39281ic47">{t(ui.footer.services)}</h2>
            <ul className="mt-5 space-y-3" data-id="element-151" data-mp="18m3sx4es5ckd">
              {services.slice(0, 4).map(s => <li key={s.id} data-id="element-152" data-mp="1cnozy94muwmn"><a href="#services" className={link} data-id="element-153" data-mp="1cnyortdxyxqr">{t(s.name)}</a></li>)}
              <li data-id="element-154" data-mp="1hms5duoiz4v5"><a href="#services" className="link-slide text-[15px] font-semibold text-gold" data-id="element-155" data-mp="1hmiem4vnotoe">{t(ui.footer.viewAll)}</a></li>
            </ul>
          </nav>

          <div className="lg:col-span-3" data-id="element-156" data-mp="1rhtvasqmkays">
            <h2 className={heading} data-id="element-157" data-mp="1rgirwu13d587">{t(ui.footer.contact)}</h2>
            <a href={business.phoneHref} className="mt-5 flex items-center gap-2 font-display text-2xl font-bold text-gold hover:text-gold-bright" data-id="element-158" data-mp="3ocghempel95q">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-159" data-mp="2af3srq70x3jm" />
              {business.phoneDisplay}
            </a>
            <dl className="mt-4 space-y-2 text-[15px]" data-id="element-160" data-mp="25nvgmmeb742r">
              <div data-id="element-161" data-mp="25mamgxvwpn5f">
                <dt className="sr-only" data-id="element-162" data-mp="21mthe5ke6s0s">{t(ui.footer.email)}</dt>
                <dd data-id="element-163" data-mp="21n1u9xgilxbz"><a href={business.emailHref} className={`${link} break-all`} data-id="element-164" data-mp="21n1spt0v9p9v">{business.email}</a></dd>
              </div>
              <div data-id="element-165" data-mp="1wlvzzv77i20c">
                <dt className="sr-only" data-id="element-166" data-mp="2tdpwzdxu7arr">{t(ui.footer.hours)}</dt>
                <dd className="text-white/80" data-id="element-167" data-mp="2tbvhif5c4av2">{business.hours}</dd>
              </div>
            </dl>
            <a href="#contact" className="btn-gold mt-6" data-id="element-168" data-mp="2paa1wm1f1ih6">{t(ui.common.getEstimate)}</a>
          </div>

          <nav aria-labelledby="footer-legal" className="lg:col-span-2" data-id="element-169" data-mp="2kf4e1hogdtqg">
            <h2 id="footer-legal" className={heading} data-id="element-170" data-mp="2fdor1k2ptd5f">{t(ui.footer.legal)}</h2>
            <ul className="mt-5 space-y-3" data-id="element-171" data-mp="18z5x6rn1a3eo">
              <li data-id="element-172" data-mp="18vrxjr5r88ax"><a href="#privacy" className={link} data-id="element-173" data-mp="18vrz3vlekgd1">{t(ui.footer.privacy)}</a></li>
              <li data-id="element-174" data-mp="13xqgtcvswl2m"><a href="#terms" className={link} data-id="element-175" data-mp="1414h8fkwmk7f">{t(ui.footer.terms)}</a></li>
              <li data-id="element-176" data-mp="2ru6dlrkst9ij"><a href="#accessibility" className={link} data-id="element-177" data-mp="2ru6f5w0g5hkn">{t(ui.footer.accessibility)}</a></li>
            </ul>
            <div className="mt-6" data-id="element-178" data-mp="2wnr46yk2b17p"><LanguageToggle data-id="element-179" data-mp="2woao2kt9vzod" /></div>
          </nav>
        </div>
      </div>

      <div className="border-t border-gold/40" data-id="element-180" data-mp="2iww0e0of7aaz">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-smoke sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-181" data-mp="2ntmietjscfz1">
          <p data-id="element-182" data-mp="3bki2t5lww8w9">© {year} Flexhire Solutions LLC. {t(ui.footer.rights)}</p>
          <p data-id="element-183" data-mp="3fkah7yxzl99j">Columbus, Ohio · {t(ui.common.workforce)}</p>
        </div>
      </div>
    </footer>;
}